import { render, staticRenderFns } from "./layoutConfig.vue?vue&type=template&id=efe418c8&scoped=true"
import script from "./layoutConfig.vue?vue&type=script&lang=js"
export * from "./layoutConfig.vue?vue&type=script&lang=js"
import style0 from "./layoutConfig.vue?vue&type=style&index=0&id=efe418c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe418c8",
  null
  
)

export default component.exports